import { Suspense } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";
import AccessibilityButton from "./AccessibilityButton";
import WhatsAppButton from "./WhatsAppButton";
import GoogleReviewsButton from "./GoogleReviewsButton";
import ScrollToTop from "./ScrollToTop";
import PageTransition from "./PageTransition";
import RouteSkeleton from "./RouteSkeleton";

export default function Layout() {
  const { pathname } = useLocation();
  const hideNavbar = pathname === "/shop";

  return (
    <div className="min-h-screen flex flex-col">
      <ScrollToTop />
      {!hideNavbar && <Navbar />}
      <main className={`flex-1 ${hideNavbar ? "" : "pt-20"}`}>
        <PageTransition routeKey={pathname}>
          <Suspense fallback={<RouteSkeleton />}>
            <Outlet />
          </Suspense>
        </PageTransition>
      </main>
      <Footer />
      <AccessibilityButton />
      <WhatsAppButton />
      <GoogleReviewsButton />
    </div>
  );
}
